(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/mybets-core-wager/assets/javascripts/parsers/wager/wager.js') >= 0) return;  svs.modules.push('/components/numbergames/mybets-core-wager/assets/javascripts/parsers/wager/wager.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
let productMapping;
if (svs.isServer) {
  const trinidadCore = require('@svenskaspelab/trinidad-core').core;
  var _trinidadCore$compone = trinidadCore.components.require('numbergames', 'product-mapping');
  productMapping = _trinidadCore$compone.productMapping;
} else {
  productMapping = svs.numbergames.productMapping;
}
function descriptions(_ref) {
  let productName = _ref.productName,
    isSystemWager = _ref.isSystemWager,
    hasJoker = _ref.hasJoker,
    descriptionItems = _ref.descriptionItems,
    rowCount = _ref.rowCount,
    packageName = _ref.packageName,
    description = _ref.description,
    extraDescription = _ref.extraDescription;
  if (descriptionItems) {
    return {
      descriptionItems
    };
  }
  if (isSystemWager && productMapping.isKeno(productName)) {
    description = "".concat(description, " ").concat(rowCount, " rader");
    if (/kung ?keno/i.test(extraDescription)) {
      extraDescription = 'med Kung Keno';
    } else {
      extraDescription = '';
    }
  }
  if (hasJoker && productMapping.isLotto(productName)) {
    extraDescription = extraDescription.replace(/krLotto/, 'kr, Lotto');
  }
  return {
    packageName,
    description,
    extraDescription
  };
}
function groupToFraction(wager) {
  if (!wager.isGroup) {
    return;
  }
  return {
    betAmount: wager.properties.customerShareAmount,
    customerFractionCount: wager.properties.customerShareCount,
    isFraction: wager.isGroup,
    fractionHolderAmount: wager.betAmount,
    fractionHolderFractionCount: wager.properties.totalShareCount
  };
}
function mapBoards(bet) {
  return bet.extNumberBoards || bet.lottoBoards || bet.kenoBoards || bet.jokerBoards || bet.erNumberBoardData && bet.erNumberBoardData.boards;
}
function parseWagerBets(wager) {
  var _bet$boards;
  if (!wager.wager || !Array.isArray(wager.wager.bets)) {
    return;
  }
  const bets = wager.wager.bets.map(bet => {
    const boards = mapBoards(bet);
    return {
      boards,
      productId: productMapping.getProductId(bet.productId),
      betAmountSalesGroup1: bet.betAmountSalesGroup1,
      betAmountSalesGroup2: bet.betAmountSalesGroup2,
      drawBetAmount: (parseInt(bet.betAmountSalesGroup1, 10) + parseInt(bet.betAmountSalesGroup2, 10)) / wager.totalDrawCount,
      rowPriceMulti: bet.rowPriceMulti,
      firstDrawNumber: bet.drawNum,
      originalNumDraws: bet.originalNumDraws
    };
  });
  const bet = bets.find(_ref2 => {
    let productId = _ref2.productId;
    return !productMapping.isJoker(productId);
  });
  const jokerBet = bets.find(_ref3 => {
    let productId = _ref3.productId;
    return productMapping.isJoker(productId);
  });
  const rowPriceMulti = Math.max(bet.rowPriceMulti, (_bet$boards = bet.boards) === null || _bet$boards === void 0 ? void 0 : _bet$boards[0].rowPriceMulti) || 1;
  if (bet.rowPriceMulti > 1) {
    bet.boards = bet.boards.map(board => _objectSpread(_objectSpread({}, board), {}, {
      rowPriceMulti
    }));
  } else if (rowPriceMulti > 1) {
    bet.rowPriceMulti = rowPriceMulti;
  }
  return {
    bet,
    jokerBet,
    bagType: wager.wager.bagType,
    hasLotto2: productMapping.isLotto(bet.productId) && parseInt(bet.betAmountSalesGroup2, 10) > 0,
    firstDrawNumber: bet.firstDrawNumber,
    originalNumDraws: bet.originalNumDraws
  };
}


function parseWager(wager) {
  const wagerProperties = wager.properties || {};

  const isCompositePackage = wagerProperties.isCompositePackage;
  const isSystemWager = wager.isSystemWager;
  const isPackageWager = Boolean(wager.packageName) && !isCompositePackage && !isSystemWager;
  return _objectSpread(_objectSpread(_objectSpread({}, descriptions(wager)), parseWagerBets(wager)), {}, {
    productId: productMapping.getProductId(wager.productName),
    productName: wager.productName,
    wagerId: wager.wagerId,
    hasJoker: wager.hasJoker,
    rowCount: wager.rowCount,
    betAmount: parseInt(wager.betAmount, 10),
    channel: wager.isSubscription ? 'prenumeration' : wagerProperties.channel,
    totalDrawCount: wager.totalDrawCount,
    hasMultipleDraws: wager.totalDrawCount > 1,
    lastDrawDate: wager.lastDrawDate,
    regWagerTime: wager.regWagerTime || wagerProperties.time,
    currentDrawNumber: wager.currentDrawNumber,
    currentAddonDrawNumber: wager.currentAddonDrawNumber,
    customerFractionCount: wager.isFraction ? 1 : 0,
    isSyndicate: wager.isSyndicate,
    syndicateId: wagerProperties.syndicateId,
    isFraction: wager.isFraction,
    isGroup: wager.isGroup,
    fractionHolderFractionCount: wager.fractionHolderFractionCount,
    fractionHolderAmount: wager.fractionHolderAmount ? parseInt(wager.fractionHolderAmount, 10) : 0,
    isUserBoards: wager.isUserBoards,
    isSubscription: wager.isSubscription,
    isCompositePackage,
    isPackageWager,
    isSystemWager,
    isSingleWager: !isSystemWager && !isPackageWager,
    lottoSplitWagerPart: wagerProperties.lottoSplitWagerPart,
    originalNumDraws: wagerProperties.originalNumDraws
  }, groupToFraction(wager));
}
if (svs.isServer) {
  module.exports = {
    parseWager
  };
} else {
  svs.numbergames.mybets_core_wager.parsers.parseWager = parseWager;
}

 })(window);